"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInputsComponent = SearchInputsComponent;
const react_1 = __importDefault(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const filter_component_1 = require("./filter-options/filter-component");
const filter_option_1 = require("./filter-options/filter-option");
function SearchInputsComponent(props) {
    return (react_1.default.createElement(Elements.StandardContainer, null,
        react_1.default.createElement(FilterOptions, Object.assign({}, props)),
        react_1.default.createElement(IncludeMnoFilterComponent, Object.assign({}, props))));
}
function IncludeMnoFilterComponent(props) {
    return (react_1.default.createElement(Elements.FlexContainerStack, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(Elements.H3, null, "Include MNO")),
        react_1.default.createElement("div", null,
            react_1.default.createElement("label", null,
                react_1.default.createElement("input", { type: "checkbox", checked: props.includeMno, onChange: () => props.toogleMNo() }),
                " ",
                "Show first 20"))));
}
function FilterOptions(props) {
    const options = filterOptionsGenerator(props);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Elements.FlexContainerRowWithPadding, null, options.map((option, index) => (react_1.default.createElement("div", { key: index }, option))))));
}
function filterOptionsGenerator(props) {
    const { searchOptionsStates, onDeletedChange, onFilterToggle, onGroupByToggle, onStatusChange, onUserInputChange, endDateOnChange, startDateOnChange } = props;
    const states = Array.from(searchOptionsStates);
    const createFilterOption = (type, title, filterComponent) => {
        const state = states.find(x => x.type === type);
        return renderFilterOption(title, state.groupBy, state.useFilter, () => onFilterToggle(type), () => onGroupByToggle(type), filterComponent);
    };
    return [
        createFilterOption("status", "Status", react_1.default.createElement(filter_component_1.ListFilterComponent, { disabled: !states.find(x => x.type === "status")
                .useFilter, onChange: onStatusChange, selectedValues: states.find(x => x.type === "status").selectedStatus.map(x => x.toString()), values: props.status.map(x => ({
                id: x.value,
                name: x.name
            })) })),
        createFilterOption("date", "Dates", react_1.default.createElement(filter_component_1.DateFilterComponent, { disabled: !states.find(x => x.type === "date")
                .useFilter, startDateOnChange: startDateOnChange, endDateOnChange: endDateOnChange, selectedEndDate: states.find(x => x.type === "date")
                .selectedEndDateStringified, selectedStartDate: states.find(x => x.type === "date")
                .selectedStartDateStringified })),
        createFilterOption("users", "Users", react_1.default.createElement(filter_component_1.InputFilterComponent, { value: states.find(x => x.type === "users")
                .selectedUsers, disabled: !states.find(x => x.type === "users")
                .useFilter, onChange: onUserInputChange }, "Username")),
        createFilterOption("deleted", "Deleted Moisture loads", react_1.default.createElement(filter_component_1.ListFilterComponent, { disabled: !states.find(x => x.type === "deleted").useFilter, onChange: onDeletedChange, selectedValues: states.find(x => x.type === "deleted").selectedDeletedOptions.map(x => x.toString()), values: props.deletedMenuItems.map(x => ({
                id: x.value,
                name: x.name
            })) }))
    ];
}
function renderFilterOption(title, filterIsChecked, groupByIsChecked, onFilterToggle, onGroupByToggle, filterComponent) {
    return (react_1.default.createElement(filter_option_1.FilterOption, { title: title, filterIsChecked: filterIsChecked, fliterComponent: filterComponent, groupByIsChecked: groupByIsChecked, onFilterToggle: onFilterToggle, onGroupByToggle: onGroupByToggle }));
}
//# sourceMappingURL=search-inputs-component.js.map